import React, { useCallback, useEffect, useState, useRef } from 'react';
import './Fpv.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

type FpvStatProps = {
  connectionType: string;
  pc: RTCPeerConnection | null;
  onBitrate: (available: number, incoming: number) => void;
};

const FpvStat: React.FC<FpvStatProps> = ({ connectionType, pc, onBitrate }) => {
    const [toltipText, setToltipText] = useState("");
    const [descriptionColor, setDescriptionColor] = useState('white');
    const [descriptionText, setDescriptionText] = useState('ТИП ПОДКЛЮЧЕНИЯ НЕ ОПРЕДЕЛЕН');
    const checkAvalibleBandwidthRef = useRef<NodeJS.Timeout | null>(null);

    const [avalibleBitrate, setAvalibleBitrate] = useState(0);
    const [incomingBitrate, setIncomingBitrate] = useState(0);

    const timeBitrateCheck = 3000;
    
    useEffect(() => {
        let text = 'ТИП ПОДКЛЮЧЕНИЯ НЕ ОПРЕДЕЛЕН';
        let color = 'white';

        switch (connectionType) {
            case 'p2p':
                text = "ПРЯМОЕ СОЕДИНЕНИЕ";
                setToltipText("Безопасное p2p соединение");
                color = '#00db00'
                break;
            case 'p2p-lan':
                text = "СОЕДИНЕНИЕ В ЛОКАЛЬНОЙ СЕТИ"
                setToltipText("Безопасное p2p соединение установлено в одной локальной сети с минимальной задержкой");
                color = '#00db00'
                break;
            case 'turn':
                text = "СОЕДИНЕНИЕ ЧЕРЕЗ СЕРВЕР!"
                color = "red";
                setToltipText("Попробуйте изменить способ подключения к интернету, отключить фаервол и vpn или подключиться напрямую без роутера. Что-то не дает установить прямое подключение");
                break;   
        }

        setDescriptionColor(color);
        setDescriptionText(text);
    }, [connectionType]);

    useEffect(() => {
        checkAvalibleBandwidthRef.current = setInterval(() => getAvailableBandwidth(pc), timeBitrateCheck);

        return () => {
            if(checkAvalibleBandwidthRef.current) clearInterval(checkAvalibleBandwidthRef.current)
        }
    }, [pc]);

    let lastBytes = 0;
    let lastTimestamp = 0;

    async function getAvailableBandwidth(pear: RTCPeerConnection | null) {
        const stats = await pear?.getStats();

        if(stats == null) {
            return;
        }

        let bitrate = 0;

        stats.forEach(report => {
            // Ищем inbound-статистику для видео
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
                if (lastTimestamp) {
                    const bytesNow = report.bytesReceived;
                    const timestampNow = report.timestamp;

                    // разница в байтах / разница во времени
                    const bytesDiff = bytesNow - lastBytes;
                    const timeDiff = (timestampNow - lastTimestamp) / 1000; // сек

                    bitrate = (8 * bytesDiff) / timeDiff; // бит/сек
                }

                // сохраняем на будущее
                lastBytes = report.bytesReceived;
                lastTimestamp = report.timestamp;
            }
        });

        setIncomingBitrate(bitrate / 1000); // бит/сек

        for (const report of stats.values()) {
            if (report.type === "candidate-pair" && report.state === "succeeded") {
                setAvalibleBitrate(report.availableIncomingBitrate / 1000);
                onBitrate(Math.round(report.availableIncomingBitrate / 1000), Math.round(bitrate / 1000));
            }
        }

        
    }

    return (
        <div className='fpv-stat'>
            <OverlayTrigger placement='top'
                overlay={
                    <Tooltip id={`tooltip-fpv-stat`}>
                        {toltipText}
                    </Tooltip>
                }>
                <div style={{color: descriptionColor}}>{descriptionText}</div>
            </OverlayTrigger>
            <div>Доступный битрейт: {avalibleBitrate.toFixed()} kbps</div>
            <div>Текущий битрейт: {incomingBitrate.toFixed()} kbps</div>
        </div>
    );
};

export default FpvStat;